<template>
  <div>
    <global-table
      :table-data="customerAsset"
      :loading="loading"
      :per-page="10"
      :table-detail="tableDetail"
      :bordered="true"
      :hover="true"
      :striped="false"
      :id-modals="'customerAssetFormAlter'"
      :redirect-detail="false"
      :edit-button="childAddButton"
      :show-add-button="false"
      :remove-button="false"
      :fields="fieldsCustomerAsset"
      addButton="Penempatan Asset Alter"
      @editForm="editForm"
      @resetForm="resetForm"
      @removeForm="removeForm"
    ></global-table>

    <b-modal
      ref="customerAssetFormAlter"
      id="customerAssetFormAlter"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Pointing asset ke konsumen</h3>
      </div>

      <div v-if="!loadingSubmit">
        <b-form
          id="customerAssetFormAlter"
          validated
          novalidate
          v-on:submit.prevent="saveCustomerAsset"
        >
          <b-row>
            <b-col sm="3">
              <b-form-group label-for="contract_number" label="Contract Number">
                <b-form-input
                  id="contract_number"
                  type="text"
                  v-model="customerAssetFormAlter.contract_number"
                  Disabled
                ></b-form-input>
                <b-form-invalid-feedback
                  >Contract Number harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group label-for="asset_owner_id" label="Nama Barang">
                <model-select
                  id="asset_owner_id"
                  :options="listAssetOwner"
                  v-model="$v.customerAssetFormAlter.asset_owner_id.$model"
                  :isError="$v.customerAssetFormAlter.asset_owner_id.$invalid"
                  isDisabled
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <div v-if="!myLoading">
                <b-form-group label-for="asset_id" label="Serial Number">
                  <model-select
                    id="asset_id"
                    :options="listAsset"
                    v-model="$v.customerAssetFormAlter.asset_id.$model"
                    :isError="$v.customerAssetFormAlter.asset_id.$invalid"
                    isDisabled
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="customerAssetFormAlter.asset_id === null"
                    class="invalid-feedback-custom"
                  >
                    Serial number harus di pilih.
                  </div>
                  <!-- <b-form-invalid-feedback>Serial number harus di pilih.</b-form-invalid-feedback> -->
                </b-form-group>
              </div>
              <div v-else>
                <loading></loading>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group label-for="assign_send_to" label="Yang Mengirim">
                <model-select
                  id="assign_send_to"
                  :options="listEmployee"
                  isDisabled
                  v-model="$v.customerAssetFormAlter.assign_send_to.$model"
                  :isError="$v.customerAssetFormAlter.assign_send_to.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="customerAssetFormAlter.assign_send_to === null"
                  class="invalid-feedback-custom"
                >
                  Driver yang mengirim harus di isi.
                </div>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group
                label-for="assign_spv_operational"
                label="SPV Sales Marketing"
              >
                <model-select
                  id="assign_spv_operational"
                  :options="listEmployee"
                  isDisabled
                  v-model="
                    $v.customerAssetFormAlter.assign_spv_operational.$model
                  "
                  :isError="
                    $v.customerAssetFormAlter.assign_spv_operational.$invalid
                  "
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="customerAssetFormAlter.assign_spv_operational === null"
                  class="invalid-feedback-custom"
                >
                  SPV Sales Marketing harus di isi.
                </div>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group label-for="description_send" label="Deskripsi">
                <b-form-textarea
                  id="description_send"
                  :rows="3"
                  :max-rows="6"
                  v-model="$v.customerAssetFormAlter.description_send.$model"
                  :state="!$v.customerAssetFormAlter.description_send.$invalid"
                  Disabled
                ></b-form-textarea>
                <b-form-invalid-feedback
                  >Deskripsi harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group
                label-for="contract_number_alias"
                label="Contract Number Alter"
              >
                <b-form-input
                  id="contract_number_alias"
                  type="text"
                  v-model="customerAssetFormAlter.contract_number_alias"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Contract Number Alter harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group
                label-for="placement_date_alias"
                label="Tanggal Penempatan Alter"
              >
                <v-date-picker
                  id="placement_date_alias"
                  :input-props="{
                    class: 'form-control',
                    placeholder: 'Tanggal Penempatan Alter',
                    required: '',
                  }"
                  :state="
                    !$v.customerAssetFormAlter.placement_date_alias.$invalid
                  "
                  v-model="
                    $v.customerAssetFormAlter.placement_date_alias.$model
                  "
                ></v-date-picker>
                <div
                  v-if="$v.customerAssetFormAlter.placement_date_alias.$invalid"
                  class="invalid-feedback-custom"
                >
                  Tanggal penempatan Alter harus di isi.
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button
              type="button"
              size="sm"
              variant="danger"
              @click="cancelCustomerAsset"
            >
              <i class="fa fa-undo"></i> Back </b-button
            >&nbsp;
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              :disabled="$v.customerAssetFormAlter.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-form>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>

    <b-modal
      ref="customerAssetRemoveForm"
      id="customerAssetRemoveForm"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      hide-footer
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Hapus pointing asset dari konsumen</h3>
      </div>

      <div v-if="!loadingSubmit">
        <b-form
          id="customerAssetRemoveForm"
          validated
          novalidate
          @submit="saveRemoveCustomerAsset"
        >
          <b-row>
            <b-col sm="6">
              <b-form-group label-for="reason" label="Alasan">
                <b-form-textarea
                  id="reason"
                  :rows="3"
                  :max-rows="6"
                  v-model="$v.customerAssetRemoveForm.reason.$model"
                  :state="!$v.customerAssetRemoveForm.reason.$invalid"
                  required
                ></b-form-textarea>
                <b-form-invalid-feedback
                  >Alasan harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>

          <div class="float-right">
            <b-button
              type="button"
              size="sm"
              variant="danger"
              @click="cancelRemoveCustomerAsset"
            >
              <i class="fa fa-undo"></i> Back </b-button
            >&nbsp;
            <b-button
              type="submit"
              size="sm"
              variant="primary"
              :disabled="$v.customerAssetRemoveForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </b-form>
      </div>

      <div v-else>
        <loading></loading>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "asset-placement",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
    customer: {
      type: [Array, Object],
      default: () => {},
    },
    customerAsset: {
      type: [Array],
      default: () => [],
    },
    listAssetOwner: {
      type: [Array],
      default: () => [],
    },
    listStatusCustomerAsset: {
      type: [Array],
      default: () => [],
    },
    listEmployee: {
      type: [Array],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    childAddButton: {
      type: Boolean,
      default: false,
    },
    isStatus: {
      type: Number,
      default: 1,
    },
  },
  validations: {
    customerAssetFormAlter: {
      asset_id: {},
      contract_number: {},
      contract_number_alias: { required },
      asset_owner_id: {},
      placement_date: {},
      placement_date_alias: { required },
      assign_send_to: {},
      assign_spv_operational: {},
      description_send: {},
    },
    customerAssetRemoveForm: {
      reason: { required },
    },
  },
  data() {
    return {
      myCustomer: {},
      myLoading: false,
      loadingSubmit: false,
      listAsset: [],
      fieldsCustomerAsset: [
        {
          key: "contract_number_download_alter",
          label: "Nomor Kontrak Alternative",
          sortable: true,
        },
        { key: "contract_number", label: "Nomor Kontrak " },
        { key: "serial_number", label: "Serial Number" },
        { key: "owner", label: "Pemilik" },
        { key: "asset_name", label: "Nama Barang" },
        {
          key: "placement_date_alias",
          label: "Tanggal Penempatan Alternative",
        },
        { key: "status_name", label: "Status" },
        { key: "description_send", label: "Deskripsi" },
        { key: "action", label: "Action", class: "text-center width-100" },
      ],
      customerAssetFormAlter: interfaces.customer_asset,
      customerAssetRemoveForm: { reason: null },
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {},
    reload(cust_id) {
      this.$emit("reload", cust_id);
    },

    resetForm: function () {
      for (var a in interfaces.customer_asset) {
        interfaces.customer_asset[a] = null;
      }
      this.customerAssetFormAlter = interfaces.customer_asset;
    },
    removeForm: function (data) {
      this.resetForm();
      this.$refs.customerAssetRemoveForm.show();
      this.customerAssetRemoveForm = data;
    },
    editForm: function (a) {
      this.resetForm();
      this.customerAssetFormAlter = a;
      if (a.placement_date_alias == null) {
        this.customerAssetFormAlter.placement_date_alias = null;
      } else {
        this.customerAssetFormAlter.placement_date_alias = new Date(
          this.customerAssetFormAlter.placement_date_alias
        );
      }
      this.customerAssetFormAlter.isEdit = 1;
      this.customerAssetFormAlter.status = this.isStatus;
    },

    saveCustomerAsset: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin mengubah asset untuk konsumen ini ?")) {
        this.loadingSubmit = true;
        this.axios
          .put("web/customer/edit-customer-asset-alter/", this.customerAssetFormAlter)
          .then((response) => {
            let _detailData = response.data.data;
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah asset konsumen",
                message: response.data.message,
              });
            }
            this.cancelCustomerAsset();
          })
          .catch((error) => {
            this.expired(error, "Tambah asset konsumen");
          })
          .finally(() => {
            this.loadingSubmit = false;
            this.reload(this.customer.id);
          });
      }
    },
    saveRemoveCustomerAsset: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menghapus asset konsumen ini ?")) {
        let customer_asset = this.customerAssetRemoveForm;
        customer_asset.status = "3";
        customer_asset.updated_by = localStorage.getItem("employee_id");
        this.axios
          .put("web/customer/change-customer-asset/", customer_asset)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Hapus asset",
                message: response.data.message,
              });
            }
            this.cancelRemoveCustomerAsset();
          })
          .catch((error) => {
            this.expired(error, "Hapus asset");
          })
          .finally(() => {
            this.reload(this.customer.id);
          });
      }
    },
    cancelCustomerAsset: function () {
      this.$refs.customerAssetFormAlter.hide();
    },
    cancelRemoveCustomerAsset: function () {
      this.$refs.customerAssetRemoveForm.hide();
    },
    onSelectAssetOwner: function (event, asset_id = "") {
      this.customerAssetFormAlter.asset_id = null;
      this.myLoading = true;
      if (asset_id === "") {
        this.axios
          .get("web/dropdown/search-by-asset-owner/" + event + "/")
          .then((response) => {
            this.listAsset = response.data.data;
          })
          .catch((error) => {})
          .finally(() => {
            this.myLoading = false;
          });
      } else {
        this.axios
          .get(
            "web/dropdown/search-by-asset-owner/" +
              event +
              "/" +
              asset_id +
              "/for-edit"
          )
          .then((response) => {
            this.listAsset = response.data.data;
          })
          .catch((error) => {})
          .finally(() => {
            this.myLoading = false;
          });
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>
